import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import vectorPunteado from '../../images/vector-punteado.svg';
import lucodsia from '../../images/lucods-ia/ia.png';
import './LucodsAI.css';

const LucodsAI: React.FC = () => {
  return (
    <section className="section-container">
      <Container fluid="lg">
        <Row className="justify-content-center">
          <Col md={10}>
            <div className="ai-header">
              <Row className="align-items-center">
                <Col md={6}>
                  <div className="about-title-container">
                    <img src={vectorPunteado} alt="AI Icon" className="about-icon" />
                    <h1 className="section-title">PLATAFORMA LUCODS IA</h1>
                    <p className="about-text">"Potenciando el futuro con inteligencia artificial avanzada y soluciones adaptativas."</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="ai-image-container">
                    <img src={lucodsia} alt="AI Platform" className="ai-image" />
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default LucodsAI;
